import styled from 'styled-components'
import { rgba, media, colors } from 'styles'
import { StyledHamburgerButton } from 'components/Sidebar/HamburgerButton'

export const cardBackground = rgba(colors.textMain, 0.85)

const StyledPayment = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  font-size: 1.5rem;
  line-height: 1.5;
  color: ${colors.textMain};
  background-color: ${colors.mainBackground};

  .inner {
    max-width: 110rem;
    padding: 3rem 4rem;
    box-sizing: border-box;
  }
  a {
    color: inherit;
  }

  .title {
    margin: 0 0 2rem;
    font-size: 2rem;
    font-weight: 700;
  }

  .bill {
    margin: 3rem 0;
    line-height: 1.3;
  }

  .inner > .Select {
    display: none;
  }
  .payment-note {
    font-size: 1.2rem;
  }

  ${media.mobile`
    .inner {
      padding: 3rem 5%;

      > .Select {
        display: block;
        margin-bottom: 3rem;
      }
    }

    ${StyledHamburgerButton} {
      display: none;
    }
  `}
`

export default StyledPayment
